/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.comment-list-header[_ngcontent-%COMP%]{padding-bottom:10px;border-bottom:1px solid var(--be-divider-default)}.comment-list-header[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--be-secondary-text);vertical-align:middle;margin-right:3px}.no-results-message[_ngcontent-%COMP%]{margin-top:30px}.no-results-message[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--be-secondary-text)}"];
export { styles as styles };
